import { createIcon } from './create-icon'

export const Envelope = createIcon({
  displayName: 'Envelope',
  paths: [
    'M170.667 768v-311.509l279.168 155.093c19.499 10.837 40.832 16.256 62.165 16.256s42.667-5.419 62.165-16.256l279.168-155.093v311.509h-682.667zM853.333 256v102.912l-320.597 178.091c-13.013 7.211-28.501 7.211-41.429 0l-320.64-178.091v-102.912h682.667zM853.333 170.667h-682.667c-47.104 0-85.333 38.229-85.333 85.333v512c0 47.104 38.229 85.333 85.333 85.333h682.667c47.104 0 85.333-38.229 85.333-85.333v-512c0-47.104-38.229-85.333-85.333-85.333z'
  ]
})
